import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {
    AvatarPurpleIcon,
    AvatarGreenIcon,
    AvatarYellowIcon,
    AvatarTealIcon,
    TripleChevronIcon,
    DripsRegularIcon,
    GoalLeadValueIcon,
    StarIcon,
} from 'shells/icon';
import {StatusBadge} from 'shells/status-badge/status-badge';
import {Body} from 'shells/typography/body';

import {getAgentName} from '../helpers';
import type {AgentKey} from '../helpers';

export function getAgentAvatar(agentKey: AgentKey): React.ComponentType<any> {
    switch (agentKey) {
        case 'SALES_PROCESS':
            return AvatarYellowIcon;
        case 'SALES_OBJECTION':
            return AvatarTealIcon;
        case 'LEAD_RESEARCH':
            return AvatarGreenIcon;
        case 'EMAIL_SEQUENCE':
        default:
            return AvatarPurpleIcon;
    }
}

export function buildAgentHeader(agentKey: AgentKey, isComingSoon: boolean): React.ReactElement {
    let iconComponent = null;

    switch (agentKey) {
        case 'LEAD_RESEARCH':
            iconComponent = <StarIcon size={16} style={{color: colors.green}} alignCenter={true} />;
            break;
        case 'SALES_PROCESS':
            iconComponent = (
                // @ts-expect-error
                <TripleChevronIcon size={16} color={colors.yellow} alignCenter={true} />
            );
            break;
        case 'SALES_OBJECTION':
            iconComponent = <GoalLeadValueIcon size={16} color={'#B9EBE7'} alignCenter={true} />;
            break;
        case 'EMAIL_SEQUENCE':
        default:
            iconComponent = (
                // @ts-expect-error
                <DripsRegularIcon size={20} color={colors.tagPurple} alignCenter={true} />
            );
            break;
    }

    return (
        <div className='flex justify-sb full-width'>
            <div className='flex gap-8'>
                <div className='flex align-center'>{iconComponent}</div>
                <Body color='dark' isBold={true}>
                    {getAgentName(agentKey)}
                </Body>
            </div>
            {isComingSoon && (
                <div className='flex align-center'>
                    <StatusBadge level='warning' text='Coming soon' />
                </div>
            )}
        </div>
    );
}

export function buildAgentDescription(agentKey: AgentKey): React.ReactElement {
    let descriptionText = null;

    switch (agentKey) {
        case 'LEAD_RESEARCH':
            descriptionText = 'Find information and additional contacts for your leads';
            break;
        case 'SALES_PROCESS':
            descriptionText = 'Create your goals and tasks to accelerate sales';
            break;
        case 'SALES_OBJECTION':
            descriptionText = 'Learn how to overcome roadblocks and close deals';
            break;
        case 'EMAIL_SEQUENCE':
        default:
            descriptionText = 'Get inspired and compose messages that get replies';
            break;
    }

    return (
        <div className='text-align-left'>
            <Body color='light'>{descriptionText}</Body>
        </div>
    );
}
